module.exports = __webpack_public_path__ + "img/97.4.d9eee0e1.png";